import { motion } from "framer-motion";
import { LOGO } from "../../utility/constains";

const ChatHeader = ({ toggleChat }) => {
  return (
    <div className="bg-[#2d486f] p-4 text-white flex items-center rounded-t-xl rounded-b-lg">
      <img
        src={LOGO}
        alt="Profile"
        className="rounded-full w-10 h-10 bg-white object-contain"
      />
      <div className="ml-3">
        <h2 className="font-bold text-lg font-heading tracking-widest">Tara</h2>
        <p className="text-sm tracking-wider font-body">
          Hi, I am Tara, your assistant here...
        </p>
      </div>
      <motion.button
        className="absolute top-3 right-3 text-black p-1 bg-white rounded-full"
        whileHover={{ scale: 1.2, rotate: 90 }}
        whileTap={{ scale: 0.9 }}
        onClick={toggleChat}
      >
        ✖
      </motion.button>
    </div>
  );
};

export default ChatHeader;
